import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useFormik } from 'formik';
import { save } from './api';
import * as yup from 'yup';
import history from '../../store/history';
import { CORPORATE_LEAD_LIST } from '../../Routes';
import * as _ from 'lodash';
import { SET_MESSAGE } from '../../actions/utils';
import useBO from '../../pages/useBO';
import useTO from '../../pages/useTO';
import CorporateLeadForm from './CorporateLeadForm';
import axios from 'axios';

export const CORPORATE_LEAD_ERRORS = {
  TAX_CODE_EXIST: 'Mã số thuế đã tồn tại',
  BANK_STAFF_CODE_REQUIRED: 'Mã số đại lý rỗng',
  TAX_CODE_REQUIRED: 'Mã số thuế không được rỗng',
  DEFAULT: 'Vui lòng thực hiện lại thao tác',
};

export const validationSchema = yup.object({
  taxCode: yup.string().required('Vui lòng nhập mã số thuế'),
});

export const useCorporateValidationSchema = () => {
  const bank = useSelector((state) => state?.lookup?.bank);

  let validationSchema = yup.object({
    taxCode: yup.string().required('Vui lòng nhập mã số thuế'),
    companyName: yup.string().required('Vui lòng nhập tên doanh nghiệp'),
    consent: yup.string().required('Khách hàng cần đồng ý với quy định của FWD'),

    // Changed according to ticket: https://hethong-int.fwd.com.vn/jira/browse/BLT-311
    // companySector: yup.string().required('Vui lòng chọn Ngành nghề'),
    // companyType: yup.string().required('Vui lòng chọn Loại doanh nghiệp'),
    // companyEmployees: yup.string().required('Vui lòng chọn Số lượng nhân viên'),
    // companyContactName: yup.string().required('Vui lòng nhập tên người liên hệ'),
    // companyContactPhoneNumber: yup.string().required('Vui lòng nhập Số điện thoại người liên hệ'),
    // companyContactJobTitle: yup.string().required('Vui lòng nhập Chức vụ người liên hệ'),
  });

  if (bank === 'VCB') {
    validationSchema = validationSchema.shape({
      productCode: yup.string().required('Vui lòng chọn loại sản phẩm'),
      bankLeaderCode: yup.string().required('Vui lòng chọn Mã lãnh đạo phòng'),
    });
  }

  return validationSchema;
};

export default function (props) {
  const bankStaffCode = useSelector((state) => state?.auth?.principal);
  const bo = useBO();
  const to = useTO();
  const initialValues = {
    bankStaffCode,
    taxCode: '',
    companyName: '',
    bankBranchCode: bo?.code,
    bankOfficeCode: to?.code,
    draft: true,
  };
  const validationSchema = useCorporateValidationSchema(props);
  const dispatch = useDispatch();
  const formProps = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values, helper) => {
      save({ ...values, draft: false })
        .then(() => history.push(CORPORATE_LEAD_LIST))
        .catch((err) => {
          let errors = _.values(err.response.data).map((e) => ({
            code: e,
            message: CORPORATE_LEAD_ERRORS[e] || CORPORATE_LEAD_ERRORS['DEFAULT'],
          }));
          dispatch({ type: SET_MESSAGE, payload: 'ERROR', errors });
          helper.setSubmitting(false);
        });
    },
    enableReinitialize: true,
  });
  const [DOBList, setDOBList] = useState([]);
  const FSCList = useSelector((state) => state?.lookup?.fsc || []);

  useEffect(() => {
    let bankBranchCode = to?.code;
    if (bankBranchCode) {
      axios
        .get(`/api/agents?bank-branch-code=${bankBranchCode}`)
        .then((response) => {
          let agentList = response?.data?.content || [];
          let DOBList = agentList?.filter((e) => 'DOB' === e.agentDesignation);
          DOBList = !DOBList?.length ? agentList?.filter((e) => 'RDOB' === e.agentDesignation) : DOBList;
          DOBList =
            DOBList?.map((e) => ({
              value: e.agentId,
              label: e.agentName,
            })) || [];
          setDOBList(DOBList);
        })
        .catch((error) => console.log(error));
    }
  }, [to]);

  return (
    <div className='mt-3'>
      <div className='container'>
        <CorporateLeadForm {...formProps} FSCList={FSCList} DOBList={DOBList} office={to} branch={bo} />
      </div>
    </div>
  );
}
